// WCD Protection Headers
export const wcdHeaders = {
  'Cache-Control': 'no-store, no-cache, must-revalidate, private',
  'Pragma': 'no-cache',
  'Expires': '0'
};

export const addWcdHeaders = (headers = {}) => ({
  ...headers,
  ...wcdHeaders
});